export default {
    getIdentifier: (state) => state.identifier,
}
